// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__q72eV","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2BVhV"};